<div class="modal-container">
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>
      <app-button [showIcon]="true" icon="close" [showLabel]="false" buttonClass="tertiary" (clicked)="onCancel()" />
    </div>
  
    <div class="modal-body">
      <ng-container *ngIf="variant === 'confirm'">
        <p [innerHTML]="description"></p>
      </ng-container>
  
      <ng-container *ngIf="variant === 'export'">
        <div class="inline-fields">
          <app-text-input
            [placeholder]="'Export As:'"
            [value]="fileName"
            (valueChange)="fileName = $event"
            [width]="'369px'"
          ></app-text-input>
          <app-text-input
            value=".xlsx"
            disabled="true"
            [width]="'55px'"
          ></app-text-input>
        </div>
      </ng-container>
  
      <ng-content *ngIf="variant === 'custom'"></ng-content>
    </div>
  
    <div class="modal-footer">
      <app-button [label]="cancelText" buttonClass="tertiary" (clicked)="onCancel()" />
      <app-button [label]="confirmText" [buttonClass]="variant === 'export' ? 'primary' : 'destructive'" (clicked)="onConfirm()" />
    </div>
  </div>
  